import React from 'react';

import PreconfirmationWarning from './preconfirmation-warning';

const { UI, Order } = Mobi2Go;

Order.onReady(() => {
    const modal = UI.ExternalModal.create(
        'preconfirmation-warning',
        <PreconfirmationWarning
            closeModal={retain_overlay => modal.close(retain_overlay)}
            isModalOpen={() => modal.isOpen()}
        />,
        {
            'data-view': 'preconfirmation-warning',
            className: 'm2g-preconfirmation-warning-modal',
        }
    );

    modal.mount();

    UI.bind('showPreconfirmationWarning', () => {
        if (Order.shouldShowPreconfirmationWarning()) {
            Order.log('preconfirmation warning shown');
            modal.open();
        } else {
            UI.trigger('progressForward', 'preconfirmation_warning');
        }
    });
});
